import { createContext, useContext, useState } from "react";
import * as React from "react";
import { throwOnNull } from "libraries/errorHelpers";

export type FiltersContextType = {
  filteredColorGroups: any[];
  setFilteredColorGroups: React.Dispatch<React.SetStateAction<any[]>>;
  filteredCompositionGroups: any[];
  setFilteredCompositionGroups: React.Dispatch<React.SetStateAction<any[]>>;
  filteredKindGroups: any[];
  setFilteredKindGroups: React.Dispatch<React.SetStateAction<any[]>>;
};

const FiltersContext = createContext<FiltersContextType | null>(null);

export const FiltersContextProvider = FiltersContext.Provider;

export const useFiltersContext = () => {
  const filtersContext = useContext(FiltersContext);

  throwOnNull(filtersContext, "Filters.FiltersContext", "Can't get context", "context is null");

  return filtersContext as FiltersContextType;
};

export const FiltersContextWrapper: React.FC<{}> = (props) => {
  const { children } = props;

  const [filteredColorGroups, setFilteredColorGroups] = useState<any[]>([]);
  const [filteredCompositionGroups, setFilteredCompositionGroups] = useState<any[]>([]);
  const [filteredKindGroups, setFilteredKindGroups] = useState<any[]>([]);

  const filtersContext = {
    filteredColorGroups,
    setFilteredColorGroups,
    filteredCompositionGroups,
    setFilteredCompositionGroups,
    filteredKindGroups,
    setFilteredKindGroups,
  };

  return <FiltersContextProvider value={filtersContext}>{children}</FiltersContextProvider>;
};
